<template>
  <div>
    <Table border :columns="columns5" :data="data5">
      <template slot-scope="{ row, index }" slot="ability">
        <Input
          type="textarea"
          v-model="row.ability"
          :autosize="true"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          @on-change="targetItemChange(row, index, 'ability')"
        />
        <span class="textareaHid" v-else>{{ row.ability }}</span>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="developTarget"
        style="width:100%"
      >
        <Input
          type="textarea"
          v-model="row.developTarget"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :autosize="true"
          @on-change="targetItemChange(row, index, 'developTarget')"
        />
        <span class="textareaHid" v-else>{{ row.developTarget }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="details" style="width:100%">
        <Input
          type="textarea"
          v-model="row.details"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :autosize="true"
          @on-change="targetItemChange(row, index, 'details')"
        />
        <span class="textareaHid" v-else>{{ row.details }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="startDate">
        <DatePicker
          type="date"
          v-model="row.startDate"
          :editable="false"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :transfer="true"
          :clearable="false"
          @on-change="targetItemChange(row, index, 'startDate')"
        />
        <span class="textareaHid" v-else>{{
          date.dateVal(row.startDate, "YYYY-MM-DD")
        }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="endDate">
        <DatePicker
          type="date"
          v-model="row.endDate"
          :editable="false"
          v-if="$store.getters.inputShowData"
          :disabled="
            (tabName != 'goalSetting' || applyEditFlag == '1') &&
              targetRevisionState
          "
          :transfer="true"
          :clearable="false"
          @on-change="targetItemChange(row, index, 'endDate')"
        />
        <span class="textareaHid" v-else>{{
          date.dateVal(row.endDate, "YYYY-MM-DD")
        }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="empDetails">
        <Input
          type="textarea"
          v-model="row.empDetails"
          v-if="$store.getters.inputShowData"
          :disabled="applyEditFlag == '1' || userDeptFlag != '1'"
          :autosize="true"
          @on-change="targetItemChange(row, index, 'empDetails')"
        />
        <span class="textareaHid" v-else>{{ row.empDetails }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="indirSupFeedback">
        <Input
          type="textarea"
          v-model="row.indirSupFeedback"
          :disabled="
            applyEditFlag == '1' || (userDeptFlag != '3' && userDeptFlag != '4')
          "
          :autosize="true"
          @on-change="targetItemChange(row, index, 'indirSupFeedback')"
        />
      </template>
      <template slot-scope="{ row, index }" slot="dirSupFeedback">
        <Input
          type="textarea"
          v-model="row.dirSupFeedback"
          v-if="$store.getters.inputShowData"
          :disabled="
            applyEditFlag == '1' || (userDeptFlag != '2' && userDeptFlag != '4')
          "
          :autosize="true"
          @on-change="targetItemChange(row, index, 'dirSupFeedback')"
        />
        <span class="textareaHid" v-else>{{ row.dirSupFeedback }}</span>
      </template>
      <template slot-scope="{ row }" slot="status">
        <span style="color:red" v-if="row.status == '新增'"
          ><!-- 新增 -->{{ $t("Add") }}</span
        >
        <span style="color:red" v-if="row.status == '删除'"
          ><!-- 删除-->{{ $t("Delete") }}</span
        >
        <span style="color:red" v-if="row.status == '编辑'"
          ><!-- 编辑 -->{{ $t("Edit") }}</span
        >
      </template>
      <template slot-scope="{ row, index }" slot="action5">
        <Button
          icon="md-trash"
          type="warning"
          size="small"
          :disabled="applyEditFlag == '1' && targetRevisionState"
          @click="deletePlan(index, row)"
        ></Button>
      </template>
    </Table>
    <div
      style="display: flex; justify-content: flex-end; margin-top:10px"
      v-if="tabName == 'goalSetting'"
    >
      <Button
        @click="addPlan()"
        :disabled="applyEditFlag == '1' && targetRevisionState"
        ><!-- 新增 -->{{ $t("Add") }}</Button
      >
    </div>
  </div>
</template>

<script>
import columns from "./columns.js";
import DateUtil from "../../../../../util/DateUtil";
export default {
  props: ["tabName"],
  data() {
    return {
      date: new DateUtil(),
      status: "",
      applyEditFlag: "",
      userDeptFlag: "",
      columns5: [],
      data5: [],
      targetRevisionState: true,
      oldData: []
    };
  },
  computed: {
    goalDevelopment() {
      return [
        {
          title: /* '能力项' */ this.$t("Competencies"),
          slot: "ability",
          align: "center",
          minWidth: 120,
          ellipsis: true
        },
        {
          title: /* '发展目标' */ this.$t("Development_Objectives"),
          slot: "developTarget",
          align: "center",
          minWidth: 120,
          ellipsis: true
        },
        {
          title: /* "详情描述(10-20-70的行动计划)" */ this.$t("longText12"),
          slot: "details",
          align: "center",
          minWidth: 300,
          ellipsis: true
        },
        {
          title: /* "开始日期" */ this.$t("Start_Date"),
          slot: "startDate",
          align: "center",
          minWidth: 120
        },
        {
          title: /* "结束日期" */ this.$t("End_Date"),
          slot: "endDate",
          align: "center",
          minWidth: 120
        },
        {
          title: /* "删除" */ this.$t("Delete"),
          slot: "action5",
          align: "center",
          minWidth: 100
        }
      ];
    },
    midDevelopment() {
      return [
        {
          title: /* '能力项' */ this.$t("Competencies"),
          slot: "ability",
          align: "center",
          minWidth: 120,
          ellipsis: true
        },
        {
          title: /* '发展目标' */ this.$t("Development_Objectives"),
          slot: "developTarget",
          align: "center",
          minWidth: 120,
          ellipsis: true
        },
        {
          title: /* "详情描述(10-20-70的行动计划)" */ this.$t("longText12"),
          slot: "details",
          align: "center",
          minWidth: 300,
          ellipsis: true
        },
        {
          title: /* "开始日期" */ this.$t("Start_Date"),
          slot: "startDate",
          align: "center",
          minWidth: 120
        },
        {
          title: /* "结束日期" */ this.$t("End_Date"),
          slot: "endDate",
          align: "center",
          minWidth: 120
        },
        {
          title: /* "员工说明" */ this.$t("Employee_Comment"),
          slot: "empDetails",
          align: "center",
          minWidth: 300,
          ellipsis: true
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 虚线上级反馈 */,
          slot: "indirSupFeedback",
          align: "center",
          minWidth: 150,
          maxWidth: 150,
          ellipsis: true,
          hidden: true
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          slot: "dirSupFeedback",
          align: "center",
          minWidth: 225,
          maxWidth: 225,
          ellipsis: true,
          hidden: true
        }
      ];
    }
  },
  created() {
    this.getMidData();
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (this.tabName == "midTermReview") {
        this.getMidData();
        // this.columns5 = this.midDevelopment;
      } else if (this.tabName == "yearEndSummary") {
        this.getMidData();
      } else {
        this.columns5 = this.goalDevelopment;
        this.$emit("onInter");
      }
    }
  },
  methods: {
    getMidData() {
      if (this.tabName == "yearEndSummary") {
        if (this.userDeptFlag == "1") {
          if (this.status < 5) {
            this.columns5 = this.midDevelopment.filter(function(e) {
              return !e.hidden;
            });
          } else {
            this.columns5 = this.midDevelopment;
          }
        } else {
          this.columns5 = this.midDevelopment;
        }
        // this.data5=[
        //     {ability:/* '能力项' */this.$t('Competencies'),developTarget:/* '发展目标' */this.$t('Development_Objectives'),id:1,details:'详情描述'},
        // ]
      } else if (this.tabName == "midTermReview") {
        this.columns5 = this.midDevelopment;
        // this.data5=[
        //     {ability:/* '能力项' */this.$t('Competencies'),developTarget:/* '发展目标' */this.$t('Development_Objectives'),id:1,details:'详情描述'},
        // ]
      } else {
        this.columns5 = this.goalDevelopment;
      }
    },
    editPlan(row, index) {
      this.openPlan = true;
      this.formItem5 = { ...row };
      this.planAction = 2;
      this.planActionIndex = index;
    },
    deletePlan(index, row) {
      if (row.status == "删除") {
        return;
      }
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        onOk: () => {
          // this.data5.splice(index, 1);
          if (
            !this.targetRevisionState &&
            (row.status == "" || row.status == "编辑")
          ) {
            row.status = "删除";
            this.$set(this.data5[index], "status", "删除");
          } else {
            this.data5.splice(index, 1);
            this.oldData.splice(index, 1);
          }
        }
      });
    },
    addPlan() {
      if (!this.targetRevisionState) {
        this.data5.push({
          ability: "",
          developTarget: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31",
          status: "新增"
        });
        this.oldData.push({
          ability: "",
          developTarget: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31",
          status: "新增"
        });
      } else {
        this.data5.push({
          ability: "",
          developTarget: "",
          details: "",
          startDate: this.date.dateVal(new Date(), "YYYY") + "-01-01",
          endDate: this.date.dateVal(new Date(), "YYYY") + "-12-31"
        });
      }
    },
    targetItemChange(row, index, key) {
      if (key == "startDate") {
        this.$set(
          this.data5[index],
          "startDate",
          this.date.dateVal(row.startDate, "YYYY-MM-DD")
        );
      } else if (key == "endDate") {
        this.$set(
          this.data5[index],
          "endDate",
          this.date.dateVal(row.endDate, "YYYY-MM-DD")
        );
      } else {
        key && this.$set(this.data5[index], key, row[`${key}`]);
      }
      // delete(this.oldData[index]['status'])
      // delete(this.data5[index]['status'])
      key == "startDate"
        ? this.$set(
            this.oldData[index],
            "startDate",
            this.date.dateVal(this.oldData[index].startDate, "YYYY-MM-DD")
          )
        : "";
      key == "endDate"
        ? this.$set(
            this.oldData[index],
            "endDate",
            this.date.dateVal(this.oldData[index].endDate, "YYYY-MM-DD")
          )
        : "";
      if (
        JSON.stringify(this.oldData[index]) !=
          JSON.stringify(this.data5[index]) &&
        !this.targetRevisionState
      ) {
        if (row.status != "新增" && row.status != "删除") {
          /* && row.status!='删除' */
          this.$set(this.data5[index], "status", "编辑");
          this.$set(this.oldData[index], "status", "编辑");
        }
      } else if (!this.targetRevisionState) {
        this.$set(this.data5[index], "status", "");
        this.$set(this.oldData[index], "status", "");
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/DevelopmentPlan.vue